import React, {Component} from 'react';
import {browserHistory} from 'react-router'

class Login extends Component {
    onFieldChange(fieldName, e) {
        if (typeof this.props.handleInputChange === 'function') {
            this.props.handleInputChange(fieldName, e.target.value)
        }
    }

    huddleForgotPassword() {
        browserHistory.push(`/ForgotPassword`)
    }

    render() {
        let validField = this.props.validField;
        let errorMessageEmail = '';
        let errorMessagePassword = '';

        for (let el in validField) {
            if (el === 'email' && validField[el] === 'invalid') {
                errorMessageEmail = <em id="email-error" class="state-error">Please enter a valid email address.</em>
            } else if (el === 'email' && validField[el] === 'empty') {
                errorMessageEmail = <em id="email-error" class="state-error">Please enter email address.</em>
            } else if (el === 'password' && validField[el] === 'empty') {
                errorMessagePassword = <em id="email-error" class="state-error">Please enter password.</em>
            } else if (el === 'password' && validField[el] === 'less') {
                errorMessagePassword = <em id="email-error" class="state-error">Please enter a valid password.</em>
            }
        }

        return (
            <div id="ctr_business" className="hiddenbox">
                <div className="section">
                    <label for="email" className="field-label">Your email address</label>
                    <label className={Object.keys(errorMessageEmail).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            className="gui-input"
                            placeholder="example@domain.com..."
                            onChange={this.onFieldChange.bind(this, 'email')}
                        />
                        <span className="field-icon"><i className="fa fa-envelope"></i></span>
                    </label>
                    {
                        errorMessageEmail
                    }
                </div>
                <div className="section">
                    <label for="password" className="field-label">Password</label>
                    <label className={Object.keys(errorMessagePassword).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                        <input
                            type="password"
                            name="password"
                            id="password"
                            className="gui-input"
                            onChange={this.onFieldChange.bind(this, 'password')}
                        />
                        <span className="field-icon"><i className="fa fa-lock"></i></span>
                    </label>
                    {
                        errorMessagePassword
                    }
                    <a
                        href="#"
                        className="forgot"
                        onClick={this.huddleForgotPassword}
                    >Forgot Password?</a>
                </div>
            </div>
        )
    }
}


export default Login;


/** WEBPACK FOOTER **
 ** ./src/Login.js
 **/